// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ClockController from "./clock_controller";
application.register("clock", ClockController);

import SelectController from "./select_controller";
application.register("select", SelectController);

import DemoLoginController from "./demo_login_controller";
application.register("demo-login", DemoLoginController);

import DragController from "./drag_controller";
application.register("drag", DragController);

import LoginController from "./login_controller";
application.register("login", LoginController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import RemovalsController from "./removals_controller";
application.register("removals", RemovalsController);

import ServiceWorkerController from "./service_worker_controller";
application.register("service_worker", ServiceWorkerController);

import TableController from "./table_controller";
application.register("table", TableController);

import NestedFormController from "./nested_form_controller.js";
application.register("nested-form", NestedFormController);

import LazyFrameController from "./lazy_frame_controller.js";
application.register("lazy-frame", LazyFrameController);

import TimeoutController from "./timeout_controller";
application.register("timeout", TimeoutController);

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import BonusRateController from "./bonus_rate_controller";
application.register("bonus-rate", BonusRateController);

import AllowancePreviewController from "./allowance_preview_controller";
application.register("allowance-preview", AllowancePreviewController);

import BonusChartController from "./bonus_chart_controller";
application.register("bonus-chart", BonusChartController);

import IdentityCheckController from "./identity_check_controller";
application.register("identity-check", IdentityCheckController);
